import { Select } from 'antd';
import React, {useId, useState} from 'react';
import { ISelectInputProps } from './types';
import { options } from 'numeral';
const { Option } = Select;
var index = -1
var fromKey = false

function SelectInput(props: ISelectInputProps) {
  let lastKeyStroke = Date.now()
  let keys = ""
  const [search, setSearch] = useState('')
  const handleKeyDown = (key: string) => {
    console.log(`Starting key down ${key}`)
    console.log(`Props.value = ${props.value}`)
    const currentIndexPosition = props.options.findIndex((option) => option.value === props.value);
    console.log(`Props.value = ${JSON.stringify(props.value)} CurrentIndexPostion=${currentIndexPosition}`)
    index = currentIndexPosition
    if (key === 'ArrowDown') {
      const nextIndex = currentIndexPosition + 1;
      if (nextIndex < props.options.length) {
        console.log("Setting onSelectChange 5")
        props.onSelectChange(props.options[nextIndex].value);
        index = nextIndex
      }
    } else if (key === 'ArrowUp') {
      const previousIndex = currentIndexPosition - 1;
      console.log("Setting onSelectChange 4")
      if (previousIndex >= 0)   props.onSelectChange(props.options[previousIndex].value);
      index = previousIndex
    } else if (key.length === 1) {
      const typedLetter = key.toLowerCase();
      let newTypedLetter = ''
      const keytimeout = 5000
      console.log(`keys=${search}`)
      console.log(`Key Check = ${ (lastKeyStroke + keytimeout) > Date.now()}`)
      if ((lastKeyStroke + keytimeout) > Date.now()) {
        console.log(`Adding text ${lastKeyStroke} ${lastKeyStroke + keytimeout} ${Date.now()} ${(lastKeyStroke + keytimeout) - Date.now()}`)
        newTypedLetter = search + typedLetter
        console.log(`Search Text = ${newTypedLetter}`)
      }
      else {
        console.log(`Resetting text ${lastKeyStroke} ${lastKeyStroke + keytimeout} ${Date.now()} ${(lastKeyStroke + keytimeout) - Date.now()}`)
        newTypedLetter = typedLetter
        console.log(`Search Text = ${newTypedLetter}`)
      }
      lastKeyStroke = Date.now()
      const filteredOptions = props.options.filter((option) => option.name.toLowerCase().startsWith(newTypedLetter));
      console.log(`Setting keys=${newTypedLetter}`)
      setSearch(newTypedLetter)
      if (filteredOptions.length > 0) {
        console.log(`Found Options ${filteredOptions.length}`)
        //const selectedIndex = filteredOptions.findIndex((option) => option === props.value.value);
        const selectedIndex = filteredOptions.findIndex((option) => option === props.value.value);
        const nextIndex = selectedIndex !== -1 ? selectedIndex + 1 : 0;
        const selectedOption = filteredOptions[nextIndex % filteredOptions.length];
        //props.onSelectChange(selectedOption);
        index = props.options.findIndex((option) => option.name.toLowerCase().startsWith(newTypedLetter))
        const newSelectedOption = filteredOptions[nextIndex % filteredOptions.length];
        console.log("Setting onSelectChange 1")
        props.onSelectChange(newSelectedOption.value);
      }
    } else if (key === 'Enter') {
      console.log(`Enter Key Index = ${index} ${props.options[index].value}`)
      console.log("Setting onSelectChange 2")
      fromKey = true
      props.onSelectChange(props.options[index].value)
    } else if (key === 'Tab') {
      //const selectedOption = filteredOptions[nextIndex % filteredOptions.length];
      fromKey = true
      console.log("Setting onSelectChange 3")
      props.onSelectChange(props.options[index].value)
    }
    console.log(`Ending key down ${key}`)
  };


  return (
    <div className="select-input-component" style={props.style}>
      {props.label && (
        <div className="select-input-component__label">
          {props.label}
        </div>
      )}
      <div {...props.innerProps} className="select-input-component__select">
        {props.options && 
          <Select 
            key={useId()}
            onInputKeyDown={(e) => handleKeyDown(e.key)} 
            autoFocus={props.autoFocus} 
            disabled={props.disabled} 
            value={props.value} 
            defaultValue={props.options[0] || ''} 
            style={{width: props.width || 220}}
            onChange={  (value) =>     { console.log(`Setting onSelectChange 7 ${value}`) ;
              if (fromKey)
                props.onSelectChange(props.options[index].value)
              else
                props.onSelectChange(value)
              fromKey=false
            }}

          >
            {props.options.map((option, index) => 
              <Option key={option.name + '-' + index + Math.random()} id={option.name + '-' + index} value={option.value}>{option.name}</Option>
            )}
          </Select>
        }
      </div>
    </div>
  )
}

export default SelectInput
